module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_13.1748733e.jpg";